import { EMPTY_OBJECT } from '../../../../constants/common'
import { ControlYear } from '../ControlYear'

import { control } from './control'

/**
 * @param {string} name
 * @param {number | null} value
 * @param {Object} defaultProps
 */
export function year(name, value, defaultProps = EMPTY_OBJECT) {
  return control(name, value, ControlYear, defaultProps)
}
